"use client";
import { FormSubmitButton } from "@general-components/FormSubmitButton";
import { ReactNode, Suspense } from "react";
import { useRouter } from "next/navigation";
import { post } from "@/utils/request";
import { message, Input } from "@basic-components";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { useSearchParams } from "next/navigation";

import * as yup from "yup";

export const schema = yup.object({
  username: yup
    .string()
    .required("请输入用户名")
    .min(2, "用户名长度不能小于2位"),
  password: yup.string().required("请输入密码").min(6, "密码长度不能小于6位"),
  code: yup
    .string()
    .required("请输入验证码")
    .length(4, "验证码长度必须为4位")
    .matches(/^[0-9a-zA-Z]+$/, "验证码只能包含数字和字母"),
});

export const Password = (props: any) => {
  return (
    <Input.Password
      {...props}
      iconRender={(visible) =>
        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
      }
    />
  );
};

export const LoginSubmit = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const redirect = searchParams.get("redirect") || "/manage";
  const handleSubmit = async (data: any) => {
    try {
      await post("/login", data);
      router.push(redirect);
    } catch (error: any) {
      message.error(error.message || "登录失败");
    }
  };
  return (
    <FormSubmitButton
      block
      type="primary"
      className="mt-6"
      htmlType="submit"
      onClick={handleSubmit}
      size="large"
    >
      {children}
    </FormSubmitButton>
  );
};

export const LoginSubmitButton = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense>
      <LoginSubmit>{children}</LoginSubmit>
    </Suspense>
  );
};
